import React, { useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Badge, Col, Button } from 'reactstrap'

import {
  DOWNLOAD_LESSON_REPORT_TEXT,
  PREPARING_LESSON_REPORT_TEXT,
} from './constants'
import CsvDownloadLink from 'components/CsvDownloadLink'
import ErrorBoundary from 'components/ErrorBoundary'
import TextLink from 'components/TextLink'
import { ButtonWrapper, StyledRow } from './component.styles'

const LicenseHeader = ({
  deleteReports,
  fetchLessonProgressReport,
  isFetchingReport,
  netSuiteAsset,
  reportData = {},
  skuCode,
  toggleEditModal,
}) => {
  useEffect(() => {
    return () => {
      deleteReports && deleteReports()
    }
  }, [deleteReports])

  const getLessonProgressReport = useCallback(() => {
    const { site } = netSuiteAsset || {}
    fetchLessonProgressReport && fetchLessonProgressReport(site.id, skuCode)
  }, [fetchLessonProgressReport, netSuiteAsset, skuCode])

  const handleEditClick = useCallback(
    event => {
      toggleEditModal()
      event.target.blur()
    },
    [toggleEditModal],
  )

  const { product, nsName } = netSuiteAsset || {}
  const { skuValue } = product || {}
  const { data, filename, headers } = reportData || {}
  const dataExists = data && data.length > 0
  const progressReportLinkText = isFetchingReport
    ? PREPARING_LESSON_REPORT_TEXT
    : DOWNLOAD_LESSON_REPORT_TEXT

  return (
    <ErrorBoundary>
      <StyledRow>
        <Col>
          <h2 className="mt-2 text-light">
            <span className="float-right">
              <ButtonWrapper>
                {skuCode === 'K8P' && !dataExists && (
                  <TextLink
                    dataTestId="get-lesson-progress-report-link"
                    disabled={isFetchingReport}
                    onClick={getLessonProgressReport}
                  >
                    {progressReportLinkText}
                  </TextLink>
                )}
                {skuCode === 'K8P' && dataExists && (
                  <CsvDownloadLink
                    data={data}
                    filename={filename}
                    headers={headers}
                  >
                    {DOWNLOAD_LESSON_REPORT_TEXT}
                  </CsvDownloadLink>
                )}

                <Button color="light" onClick={handleEditClick}>
                  <i className="fas fa-pencil-alt" />
                  &nbsp;Edit
                </Button>
              </ButtonWrapper>
            </span>
            License&nbsp;
            <Badge color="light">{nsName}</Badge>
            <Badge color="light">SKU: {skuValue}</Badge>
          </h2>
        </Col>
      </StyledRow>
    </ErrorBoundary>
  )
}

LicenseHeader.propTypes = {
  deleteReports: PropTypes.func,
  fetchLessonProgressReport: PropTypes.func,
  isFetchingReport: PropTypes.bool,
  netSuiteAsset: PropTypes.object,
  reportData: PropTypes.array,
  skuCode: PropTypes.string.isRequired,
  toggleEditModal: PropTypes.func.isRequired,
}

export default LicenseHeader
